import React from 'react';

export interface HighlightTextOptions {
  className?: string;
  caseSensitive?: boolean;
}

export const highlightText = (
  text: string,
  searchQuery: string,
  options: HighlightTextOptions = {}
): React.ReactNode => {
  if (!searchQuery || !text) return text;

  const { className = '', caseSensitive = false } = options;
  const flags = caseSensitive ? 'g' : 'gi';

  try {
    const escapedQuery = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedQuery})`, flags));

    const content = parts.map((part, i) => {
      const isMatch = caseSensitive ? part === searchQuery : part.toLowerCase() === searchQuery.toLowerCase();

      return isMatch ? (
        <span key={i} className={className}>
          {part}
        </span>
      ) : (
        part
      );
    });

    return <span>{content}</span>;
  } catch (error) {
    console.warn('Failed to highlight text:', error);
    return text;
  }
};
